<template>
  <div
    class="mixer-player"
    :class="includeChat ? 'mixer-player-with-chat' : ''"
  >
    <div class="player">
      <iframe
        :height="playerHeight"
        :width="playerWidth"
        :disableCostream="disableCostream"
        :disableLowLatency="disableLowLatency"
        :muted="muted"
        :disableLinks="disableLinks"
        :hideChannel="hideChannel"
        :mixplay="mixplay"
        :src="`https://mixer.com/embed/player/${channel}`"
        composer="true"
      ></iframe>
    </div>
    <div class="chat" v-if="includeChat">
      <iframe
        :src="`https://mixer.com/embed/chat/${channel}`"
        :width="chatWidth"
        height="100%"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixer-player',
  props: {
    playerHeight: {
      type: String,
      default: '480'
    },
    playerWidth: {
      type: String,
      default: '854'
    },

    includeChat: {
      type: Boolean,
      default: false
    },
    chatWidth: {
      type: String,
      default: '340'
    },
    channel: {
      type: String,
      required: true,
      default: 'mixer'
    },
    // Set this to true to prevent the Embed from display CoStreams.
    disableCostream: {
      type: Boolean,
      default: false
    },
    // Set this to true to prevent links within the Embed
    disableLinks: {
      type: Boolean,
      default: false
    },
    // Set this to true to disable FTL Playback. This will make the video HLS instead.
    disableLowLatency: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '480'
    },
    // Set this to true to hide the channel/"Watch on Mixer" link for this embed.
    hideChannel: {
      type: Boolean,
      default: false
    },
    // Set this to true to show MixPlay controls in the embed. Defaults to false.
    mixplay: {
      type: Boolean,
      default: false
    },
    // mute the video player on load.
    muted: {
      type: Boolean,
      default: true
    },
    // Provide a VOD Id here to Embed a VOD.
    vod: String,
    // Provide a time here to skip to this time within the vod
    t: String,
    width: {
      type: String,
      default: '854'
    }
  },
  created() {
    // if (this.includeChat) {
    //   // this.playerWidth = `calc(100% - ${this.chatWidth}px)`;
    // }
  }
};
</script>

<style lang="scss" scoped>
.mixer-player {
  background-color: rgba(#212c3d, 0.85);
  max-width: 100%;
  position: relative;
  height: 100%;
  width: 100%;
  padding-bottom: 56%;

  & iframe {
    height: 100%;
    position: absolute;
    width: 100%;
  }
}
.player {
  height: 100%;
  .mixer-player-with-chat & {
    height: 50%;
  }
  width: 100%;
  @media all and (min-width: 768px) {
    height: 100%;
  }
}

.player > iframe {
  width: 100%;
  height: 100%;
  max-width: 100%;
  .mixer-player-with-chat & {
    @media all and (min-width: 768px) {
      padding-right: 340px;
    }
  }
}

.chat {
  height: 50%;
  width: 100%;
  @media all and (min-width: 768px) {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 340px;
  }
  & iframe {
    width: 100%;
  }
}
</style>
